const healthCheck = [
  {
    path: '/health-check',
    name: 'StrategicExpressWeb.HealthCheck',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/components/HealthCheck.vue'),
  },
];

export {
  healthCheck,
};
